import React from 'react';
import classNames from 'classnames';
import Translator from 'bazinga-translator';

export default class NewPerson extends React.Component {
    constructor() {
        super();
        this.state = {
            name: '',
            email: '',
            phone: ''
        };
        this.getAllInputdata = this.getAllInputdata.bind(this);
        this.setEditable = this.setEditable.bind(this);
        this.addPerson = this.addPerson.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.state !== nextState
    }

    componentWillUpdate(nextProps, nextState) {

    }

    setValueToInput(id, nextProps) {
        let hiddenInput = document.getElementById(id), newValue = JSON.stringify(nextProps.persons);
        if (hiddenInput.value !== newValue) {
            hiddenInput.value = newValue
        }
    }

    setEditable(e) {
        e.preventDefault();
    }

    addPerson(e) {
        e.preventDefault();
        const { actions, person } = this.props;

        let data = {
            name: this.state.name,
            email: this.state.email,
            phone: this.state.phone
        };
        actions.handleAddPerson(data);
        this.setState({name: '', email : '', phone: ''})

    }

    getAllInputdata() {
        return {
            name: this.refs.name.value,
            email: this.refs.email.value,
            phone: this.refs.phone.value
        }
    }

    handleNameChange(e) {
        let value = e.target.value;
        this.setState({name : value});
    };

    handleEmailChange(e) {
        let value = e.target.value;
        this.setState({email : value});
    };

    handlePhoneChange(e) {
        let value = e.target.value;
        this.setState({phone : value});
    };

    render() {
        const { person } = this.props;
        let containerClass = classNames({
            'contact-person': true
        });

        return (
        <div className={containerClass}>
            <div className="contact-person__col">
                <div className="input">
                    <label htmlFor="name">{Translator.trans('edit_mode.modal.clients.contact_person.name', [], 'app')}<em>*</em></label>
                    <input type="text" id="name" ref="name"
                           onChange={this.handleNameChange}
                           value={this.state.name}
                    />
                </div>
            </div>
            <div className="contact-person__col">
                <div className="input">
                    <label htmlFor="e-mail">{Translator.trans('edit_mode.modal.clients.contact_person.email', [], 'app')}<em>*</em></label>
                    <input type="text"
                           id="e-mail"
                           onChange={this.handleEmailChange}
                           ref="email" value={this.state.email}
                    />
                </div>
            </div>
            <div className="contact-person__small-col">
                <div className="input"><label htmlFor="phone">{Translator.trans('edit_mode.modal.clients.contact_person.phone', [], 'app')}</label>
                    <input type="text" id="phone"
                           onChange={this.handlePhoneChange}
                           ref="phone" value={this.state.phone}/>
                </div>
            </div>
            <div className="contact-person__options">
                <a href="#" className="btn -full" onClick={this.addPerson}>{Translator.trans('edit_mode.modal.clients.contact_person.add', [], 'app')}</a>
            </div>
        </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/_app/clients/components/new-person.jsx